export default function asArray<T>(value: T, fallback?: T[]): T[] {
  if (value === undefined && fallback) return fallback;
  if (value === undefined) throw new Error("value is undefined");
  return Array.isArray(value) ? value : [value];
}
